export const ANNOTATION_COLORS = [
  '#fbbf24',
  '#60a5fa',
  '#34d399',
  '#f472b6',
  '#f97316',
  '#f87171',
];

export const DEFAULT_TEXT_WIDTH = 240;
export const DEFAULT_RECT_SIZE = { width: 220, height: 140 };
export const MIN_RECT_SIZE = { width: 80, height: 60 };

export function createAnnotationId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `ann-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 8)}`;
}

export function pickAnnotationColor(seed?: number): string {
  const index =
    typeof seed === 'number'
      ? Math.abs(seed) % ANNOTATION_COLORS.length
      : Math.floor(Math.random() * ANNOTATION_COLORS.length);
  return ANNOTATION_COLORS[index];
}

export function colorFromId(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i += 1) {
    hash = (hash * 31 + id.charCodeAt(i)) | 0;
  }
  return pickAnnotationColor(hash);
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

export function toRgba(color: string, alpha: number): string {
  if (color.startsWith('#')) {
    const hex = color.replace('#', '');
    const normalized =
      hex.length === 3
        ? hex
            .split('')
            .map((c) => c + c)
            .join('')
        : hex;
    if (normalized.length === 6) {
      const r = parseInt(normalized.slice(0, 2), 16);
      const g = parseInt(normalized.slice(2, 4), 16);
      const b = parseInt(normalized.slice(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  }
  return color;
}
